<!--
  Author: Jake G. | Vesper Cloud Solutions
  Copyright (c) 2025
-->
<div
  class="bg-(--toolbar-color) text-(--toolbar-text-color) grid xl:grid-cols-[1fr_auto_1fr] grid-cols-[auto_auto_auto] h-[50px]">
  <a routerLink="/" class="w-fit" aria-label="Home" i18n-aria-label="@@homeLabel">
    <img src="assets/images/HoganLogo.jpg" alt="Hogan Logo" class="h-[50px]" i18n-alt="@@logoAlt" />
  </a>
  <div class="w-6xl flex flex-row items-center">
    @if(this.clients){ <app-client-selector (clientChanged)="setActiveClient($event)" [clients]="clients"
      class="grow flex items-center space-x-2" /> }@else{ <span class="grow flex items-center space-x-2"></span> }
    <div class="flex items-center search-wrapper">
      <button matIconButton aria-label="Search" i18n-aria-label="@@searchLabel" (click)="toggleSearch()">
        <mat-icon class="text-xs" fontIcon="search"></mat-icon>
      </button>
      <div class="search-container" [class.open]="searchOpen()">
        <input type="text" class="search-input ml-1" placeholder="Search..." i18n-placeholder
          (input)="onSearchInput($event)" (keydown.enter)="submitSearch()" />
      </div>
    </div>
    <button matIconButton aria-label="Help" [matMenuTriggerFor]="menu" i18n-aria-label="@@helpLabel">
      <mat-icon fontIcon="help_outline"></mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <a mat-menu-item i18n-aria-label aria-label="User Guide" href="/assets/Halo Lite User Guide.pdf" target="_blank"
        rel="noopener">
        <mat-icon aria-hidden="true" fontSet="material-symbols-outlined">quick_reference_all</mat-icon>
        <span i18n>User Guide</span>
      </a>
      @if (policyUrl) {
      <a mat-menu-item i18n-aria-label aria-label="Hogan Privacy Policy" [href]="policyUrl" target="_blank"
        rel="noopener">
        <mat-icon aria-hidden="true" fontSet="material-symbols-outlined">visibility</mat-icon>
        <span i18n>Hogan Privacy Policy</span>
      </a>
      } @if (termsUrl) {
      <a mat-menu-item i18n-aria-label aria-label="Terms of Use" [href]="termsUrl" target="_blank" rel="noopener">
        <mat-icon aria-hidden="true" fontSet="material-symbols-outlined">text_ad</mat-icon>
        <span i18n>Terms of Use</span>
      </a>
      }
    </mat-menu>
    <button matIconButton aria-label="Exit" (click)="logout()" i18n-aria-label="@@exitLabel">
      <mat-icon fontIcon="logout"></mat-icon>
    </button>
  </div>
</div>
<main [class.opacity-0]="isNavigating()" class="transition-opacity duration-250 ease-in-out">
  <router-outlet></router-outlet>
</main>
<div [class.hidden]="!isNavigating()"
  class="fixed top-0 left-0 right-0 bottom-0 bg-(--loading-overlay-color) opacity-95 z-2"></div>
<div [class.hidden]="!isNavigating()"
  class="fixed top-0 w-screen h-screen flex flex-col items-center justify-center gap-10 z-3">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  <div class="text-white text-3xl">
    Loading...
  </div>
</div>